import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "section", "empty"]

  filter(event) {
    const query = event.target.value.trim().toLowerCase()
    let visibleItems = 0

    this.itemTargets.forEach((item) => {
      const visible = item.textContent.toLowerCase().includes(query)
      item.classList.toggle("d-none", !visible)
      if (visible) visibleItems += 1
    })

    this.sectionTargets.forEach((section) => {
      const hasVisibleItems = section.querySelector(
        '[data-not-installed-search-target~="item"]:not(.d-none)'
      )
      section.classList.toggle("d-none", !hasVisibleItems)
    })

    this.emptyTarget.classList.toggle("d-none", visibleItems > 0)
  }
}
